import { AppConfig } from '../types/app';

export type GandalfIDPEndpoints = {
  default: string;
  customDomain?: string;
};

/**
 * Determines if the new IDPC endpoint should be used
 * @param config The application configuration
 * @returns True if the new IDPC endpoint should be used, false otherwise
 */
export function shouldUseNewIdpcEndpoint(config: AppConfig): boolean {
  return (
    config.enableNewIdpCEndpoints === 'true' && Boolean(config.newIdpcEndpoint)
  );
}

/**
 * Returns the appropriate IDPC endpoint based on configuration
 * @param config The application configuration
 * @returns The endpoint URL to use
 */
export function getIdpcEndpoint(config: AppConfig): string {
  return shouldUseNewIdpcEndpoint(config)
    ? config.newIdpcEndpoint!
    : config.gandalfIDPEndpoint;
}

/**
 * Returns the GandalfIDPConfigPublisher endpoints based on configuration.
 *
 * @param config The application configuration
 * @returns The endpoint URLs
 */
export function getGandalfIDPEndpoints(config: AppConfig): GandalfIDPEndpoints {
  return {
    default: config.gandalfIDPEndpoint,
    customDomain: config.gandalfIDPCustomDomainEndpoint,
  };
}
